<template>
  <div class="my-scenes-body">
    <div>
      <div class="my-scenes-filter-box">
        <div class="my-scenes-filter-tab">
          <div class="my-scenes-filter-search">
            <a-input-search
              placeholder="请输入成果名称搜索"
              v-model="searchVal"
              @search="searchBtn"
            >
              <a-icon type="search" slot="enterButton" />
            </a-input-search>
          </div>
        </div>
      </div>
      <div class="my-scenes-list">
        <a-table
          :columns="columns"
          :data-source="commentData"
          :pagination="pages"
          @change="pageChange"
        >
          <template slot="achvName" slot-scope="text, record">
            <span
              class="results-detail"
              @click="$router.push(`/homeResults/detail?id=${record.achvId}`)"
              >{{ text }}</span
            >
          </template>
          <div slot="operating" slot-scope="text, record">
            <div class="my-scenes-operating">
              <span @click="delComment(record.id)">删除</span>
            </div>
          </div>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommentList, getCommentDelete } from "@/api/interactive";
const columns = [
  {
    title: "成果名称",
    dataIndex: "achvName",
    key: "achvName",
    ellipsis: true,
    width: 300,
    scopedSlots: { customRender: "achvName" },
  },
  {
    title: "评论内容",
    dataIndex: "content",
    key: "content",
    width: 600,
  },
  {
    title: "评论时间",
    dataIndex: "commentTime",
    key: "commentTime",
  },
  {
    title: "操作",
    dataIndex: "operating",
    key: "operating",
    scopedSlots: { customRender: "operating" },
  },
];
export default {
  data() {
    return {
      commentData: [],
      columns,
      pages: {
        showSizeChanger: true,
        showQuickJumper: true,
        current: 1,
        defaultPageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 项`,
      },
      searchVal: "",
      psge: {
        size: 10,
        current: 1,
      },
    };
  },
  mounted() {
    this.loadgetCommentList();
  },
  methods: {
    loadgetCommentList() {
      let data = {
        keywords: this.searchVal,
      };
      getCommentList(this.psge, data).then((res) => {
        this.commentData = res.data.records;
        this.pages.total = res.data.total;
      });
    },
    searchBtn() {
      this.loadgetCommentList();
    },
    pageChange(e) {
      this.psge.current = e.current;
      this.pages.current = e.current;
      this.loadgetCommentList();
    },
    delComment(id) {
      let _this = this;
      this.$confirm({
        title: "您确定删除吗?删除后不可恢复！",
        onOk() {
          getCommentDelete(id).then(() => {
            _this.loadgetCommentList();
          });
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.results-detail {
  cursor: pointer;
  &:hover {
    color: #1abc9c;
  }
}
.my-scenes-body {
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
  > div {
    width: 1240px;
    margin: 0 auto;
  }
  .my-scenes-filter-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .my-scenes-filter-tab {
      display: flex;
      align-items: center;
      .my-scenes-filter-search {
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        overflow: hidden;
      }
    }
  }
  .my-scenes-list {
    background: #fff;
    margin-top: 24px;

    .my-scenes-operating {
      display: flex;
      > span {
        cursor: pointer;
        color: #1abc9c;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
<style>
.my-scenes-filter-search input {
  width: 280px !important;
  height: 32px;
  background: #ffffff;
  border: none;
  border-radius: 2px;
}
.my-scenes-filter-search button {
  background: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
  color: #8c8c8c !important;
  box-shadow: none;
  border-radius: 0;
}
.my-scenes-list th,
.my-scenes-list td {
  border-color: #f0f0f0 !important;
}
.ant-table-pagination.ant-pagination {
  margin: 16px;
}
</style>
